/**
 * SectionHeader — Title + optional "see all" action link
 *
 * Used for: content section headers on home/browse screens
 */
import type { ReactNode } from 'react'
import { styled, XStack, Text as TamaguiText, type GetProps } from 'tamagui'

const SectionHeaderFrame = styled(XStack, {
  name: 'SectionHeader',
  jc: 'space-between',
  ai: 'center',
  mb: '$sm',
})

const SectionTitle = styled(TamaguiText, {
  name: 'SectionTitle',
  fontFamily: '$cursive',
  fontSize: 18,
  color: '$color',
})

const SectionAction = styled(XStack, {
  name: 'SectionAction',
  tag: 'button',
  cursor: 'pointer',
  ai: 'center',
  gap: 2,
  pressStyle: { opacity: 0.7 },
})

const SectionActionText = styled(TamaguiText, {
  name: 'SectionActionText',
  fontFamily: '$body',
  fontSize: 14,
  fontWeight: '600',
  color: '$colorPrimary',
})

type SectionHeaderFrameProps = GetProps<typeof SectionHeaderFrame>

interface SectionHeaderProps extends SectionHeaderFrameProps {
  title: string
  actionLabel?: string
  actionIcon?: ReactNode
  onAction?: () => void
}

export const SectionHeader = SectionHeaderFrame.styleable<SectionHeaderProps>(
  ({ title, actionLabel, actionIcon, onAction, ...props }, ref) => {
    return (
      <SectionHeaderFrame ref={ref} {...props}>
        <SectionTitle>{title}</SectionTitle>
        {(actionLabel || actionIcon) && (
          <SectionAction onPress={onAction}>
            {actionLabel && <SectionActionText>{actionLabel}</SectionActionText>}
            {actionIcon}
          </SectionAction>
        )}
      </SectionHeaderFrame>
    )
  },
)
